// extracted by mini-css-extract-plugin
export var anchored = "component-module--anchored--fa687";
export var faqContainer = "component-module--faqContainer--e8166";